import { c as _c } from "react/compiler-runtime";
import type { FolderPopulated } from "@vita-learning/types";
import type { FC } from "react";
interface FolderItemProps {
  readonly folder: FolderPopulated;
}
export const FolderItem: FC<FolderItemProps> = t0 => {
  const $ = _c(2);
  const {
    folder
  } = t0;
  let t1;
  if ($[0] !== folder.title) {
    t1 = <div className="folder-item"><div><h4>{folder.title}</h4></div></div>;
    $[0] = folder.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};